(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["compose-multiplatform-html-unified-demo"] = factory();
	else
		root["compose-multiplatform-html-unified-demo"] = factory();
})(globalThis, () => {
return 